import { alertSlice } from "components/store/reducers/shared/alertReducer";

export const {
  showErrorAlertMessage,
  showInfoAlertMessage,
  showSuccessAlertMessage,
  clearAlertMessage,
} = alertSlice.actions;
